import React, {Component} from 'react'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import {Form} from 'semantic-ui-react'

class Lista extends Component{
	constructor(props){
		super(props)
		this.app= firebase;
		this.database = this.app.firestore().collection('Info').doc('info')
		this.excluir=Array.isArray(this.props.excluir) ? this.props.excluir : []
		this.state = {
			options: [],
		}
	}

	childAdded= async ()=>{
		const docRef = await this.database.get()
		if (docRef.exists) {
			const data = docRef.data().roles;
			const lista = []
			for(let i=0; i<data.length; i++){
				if(this.excluir.includes(data[i])){
					continue
				}
				lista.push({key:i, value:data[i], text:data[i]})
			}
			this.setState({
				options:lista,
			})
		} else {
			console.log('Document does not exist');
		}
	}
	componentDidMount(){
		this.database.onSnapshot(this.childAdded)
	}
	render(){
		//console.log(this.state.options)
		return (
		<div className='SelectContainer'>
			<Form.Dropdown 
				selection
				search
				options={this.state.options}
				{...this.props}
			/>
		</div>
		)
	}
}

export default Lista;